<template>
    <div class="card">
        <a :class="{disabled: disabled}" v-b-toggle="disabled ? false : id" role="tab">
            <div class="card-header d-flex justify-content-between pt-0">
                <h5>
                    {{ invoices.length }}
                    <span class="badge" :class="badge">{{ state | stateToName | titleLang | lang }}</span>
                </h5>
                <div class="d-flex align-items-center" v-if="! disabled">
                    <i class="material-icons when-closed">
                        keyboard_arrow_right
                    </i>
                    <i class="material-icons when-opened">
                        keyboard_arrow_down
                    </i>
                </div>
            </div>
        </a>
        <b-collapse :id="id" accordion="invoice-accordion" role="tabpanel">
            <div class="list-group list-group-flush">
                <a :href="action(invoice)" v-for="invoice in invoices" class="list-group-item list-group-item-action">Invoice
                    #{{ invoice.id }}</a>
            </div>
        </b-collapse>
    </div>
</template>

<script>
  import {kebabCase} from 'lodash/string';

  export default {
    name: 'InvoiceAccordionItem',
    props: {
      invoices: {
        type: Array,
        required: true,
      },
    },
    computed: {
      disabled() {
        return this.invoices.length < 1;
      },
      state() {
        return this.$vnode.key;
      },
      id() {
        return kebabCase(`accordion-${this.state}`);
      },
      badge() {
        const type = this.getBadgeType(this.state);

        return `badge-${type}`;
      },
    },
    filters: {
      stateToName(state) {
        return state.split('\\').pop();
      },
      titleLang: (word) => {
        return `states.client.${word}.title`;
      },
    },
    methods: {
      action(invoice) {
        return invoice.actions.find(action => ['edit', 'view'].includes(action.action)).url || '#';
      },
      getBadgeType(state) {
        switch (state) {
          case 'App\\States\\Invoice\\Draft':
            return 'light';
          case 'App\\States\\Invoice\\Rejected':
            return 'danger';
          case 'App\\States\\Invoice\\Pending':
            return 'info';
          case 'App\\States\\Invoice\\Accepted':
            return 'success';
          case 'App\\States\\Invoice\\Sent':
            return 'primary';
          case 'App\\States\\Invoice\\PaymentReceived':
            return 'info';
          case 'App\\States\\Invoice\\PaymentSent':
            return 'primary';
          case 'App\\States\\Invoice\\Done':
            return 'success';
        }
        return 'secondary';
      },
    },
  };
</script>

<style lang="scss" scoped>
    @use "sass:color";
    @import "../../sass/_variables.scss";

    .card {
        transition-duration: 0.2s;
        position: relative;
        margin-bottom: 5px;

        a.collapsed .when-opened,
        a:not(.collapsed) .when-closed {
            display: none;
        }

        a {
            cursor: default;

            &:not(.disabled):hover {
                cursor: pointer;
                transition-duration: 0.2s;
                background-color: $input-bg;

                .badge {
                    transition-duration: 0.2s;
                    opacity: 1;
                }
            }

            .card-header {
                h5 {
                    font-family: $font-family-secondary;
                    font-size: 15px;
                    font-weight: 700;
                    line-height: 15px;
                    margin-top: 9px;
                    width: fit-content;

                    small {
                        font-weight: 400;
                        font-size: 12px;
                        color: $card-title-description-color;
                    }
                }

                .badge {
                    opacity: 0.7;
                    margin-left: 19px;
                    transition-duration: 0.2s;
                    font-weight: 400;
                    font-size: 13px;
                }

                i {
                    color: $accent-bg;
                }
            }
        }

        .list-group-item {
            background-color: $panel-bg;
            padding: 0.5rem 1.25rem;
        }

        .list-group-item {
            color: color.scale($card-title-color, $lightness: -20%);
        }

        .list-group-item-action:hover, .list-group-item-action:focus {
            cursor: pointer;
            transition-duration: 0.2s;
            background-color: $input-bg;
        }

        .list-group-flush:first-child .list-group-item:first-child {
            border-top: 1px solid rgba(0, 0, 0, 0.125);
        }

        a {
            color: color.scale($card-title-color, $lightness: -20%);
            font-family: $font-family-secondary;
            font-size: 13px;
            font-weight: 400;
            line-height: 13px;
        }
    }
</style>
